/*
  owner 2026-09-18: ties a sale back to the video that started it.

  Opens and watch time answer "is this video watched". This answers "does it
  SELL", which is the only one that decides what gets filmed next.

  Two records are written, because they survive different things:

  - a GA4 `video_add_to_cart` event, so videos can be ranked in Analytics with
    nothing to set up on the Shopify side;
  - a CART ATTRIBUTE, which Shopify carries all the way onto the ORDER. No
    theme script runs inside checkout, so this is the only way the finished
    order can say which video earned it. It shows on the order in admin under
    Additional details, and is not shown to the customer anywhere.

  Last touch wins and the reference expires after 7 days: a video watched a
  fortnight ago did not sell today's order.

  Nothing here is load-order sensitive. The video players announce
  `sm:video-product-click`; sm-cart-tracker.js announces `sm:cart-add`. If this
  file is removed, both carry on unchanged and simply go unheard.
*/
(function () {
  'use strict';

  // card-product.liquid can pull this in once per section, so a homepage run
  // would otherwise attach several listeners and write the attribute twice
  if (window.__smVideoAttribInit) return;
  window.__smVideoAttribInit = true;

  var KEY = 'sm_video_ref';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var ref = JSON.parse(raw);
      if (!ref || !ref.video || !ref.ts) return null;
      if (Date.now() - ref.ts > TTL_MS) { window.localStorage.removeItem(KEY); return null; }
      return ref;
    } catch (e) { return null; }   // private mode, full quota: attribution is never worth an error
  }

  function write(ref) {
    try { window.localStorage.setItem(KEY, JSON.stringify(ref)); } catch (e) {}
  }

  function handleOf(url) {
    var m = /\/products\/([^/?#]+)/.exec(String(url || ''));
    return m ? m[1] : '';
  }

  document.addEventListener('sm:video-product-click', function (e) {
    var d = (e && e.detail) || {};
    if (!d.video) return;
    write({
      video: String(d.video),
      title: String(d.title || '').slice(0, 100),
      handle: handleOf(d.url),
      placement: String(d.placement || 'video'),
      ts: Date.now()
    });
  });

  document.addEventListener('sm:cart-add', function () {
    var ref = read();
    if (!ref) return;

    var hours = Math.round((Date.now() - ref.ts) / 3600000);

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'video_add_to_cart', {
          video_id: ref.video,
          video_title: ref.title,
          item_id: ref.handle,
          placement: ref.placement,
          hours_since_video: hours
        });
      }
    } catch (err) {}

    // The attribute goes on the CART, which becomes the order. Shopify merges
    // the keys sent here into whatever attributes the cart already carries, so
    // this cannot disturb anything else that writes to them.
    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Video Source': ref.video,
            'Video Placement': ref.placement,
            'Video Product': ref.handle
          }
        })
      })['catch'](function () {});
    } catch (err) {}
  });
})();
